import { ConcreteEncodable } from "./ConcreteEncodable";

import { BenchmarkCrossMarketRateImplEncoder } from "../../encoder/BenchmarkCrossMarketRateImplEncoder";

import * as CubiqTS from "../../index";
import { BenchmarkCrossMarketRate } from "../BenchmarkCrossMarketRate";

export class BenchmarkCrossMarketRateImpl
  extends ConcreteEncodable
  implements BenchmarkCrossMarketRate
{
  public static enType: string = "com.bcdfx.streaming.impl.BenchmarkCrossMarketRateImpl";

  /*FID=1*/
  public askPrice: CubiqTS.BigNumber | null = null;
  /*FID=2*/
  public askSize: CubiqTS.BigNumber | null = null;
  /*FID=3*/
  public bidPrice: CubiqTS.BigNumber | null = null;
  /*FID=4*/
  public bidSize: CubiqTS.BigNumber | null = null;
  /*FID=5*/
  public tenor: CubiqTS.Tenor;
  /*FID=6*/
  public valueDate: CubiqTS.StandardDate | null = null;
  /*FID=7*/
  public isTradable: boolean;
  /*FID=8*/
  public publicationTime: CubiqTS.Long | null = null;
  /*FID=9*/
  public rateId: string;
  /*FID=10*/
  public ndfHorizon: boolean;
  /*FID=11*/
  public fixingTime: CubiqTS.Long | null = null;
  /*FID=12*/
  public product: CubiqTS.Product;
  /*FID=13*/
  public numPips: number;
  /*FID=100*/
  public messageId: string;
  /*FID=1000*/
  public components: Array<CubiqTS.MarketDataEvent> | null = null;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = BenchmarkCrossMarketRateImplEncoder.Instance;
    this.setEncodableType(BenchmarkCrossMarketRateImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "BenchmarkCrossMarketRateImpl[" +
      "askPrice=" +
      this.askPrice +
      "askSize=" +
      this.askSize +
      "bidPrice=" +
      this.bidPrice +
      "bidSize=" +
      this.bidSize +
      "tenor=" +
      this.tenor +
      "valueDate=" +
      this.valueDate +
      "isTradable=" +
      this.isTradable +
      "publicationTime=" +
      this.publicationTime +
      "rateId=" +
      this.rateId +
      "ndfHorizon=" +
      this.ndfHorizon +
      "fixingTime=" +
      this.fixingTime +
      "product=" +
      this.product +
      "numPips=" +
      this.numPips +
      "messageId=" +
      this.messageId +
      "components=" +
      this.components +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
